var _ = require("../../../uam/module.js")(module.exports, {
  namespace: "ua.preview.date",
  title: "Control Preview: Date",
  description: "Read-only preview renderer for ua.select.date values (accounting dates such as 20261023040000): shows the readable date.",
  fields: {
    "value": { title: "Value", type: "*", description: "Accounting date (YYYYMMDD[HHMMSS]), ISO date string, or Date." }
  }
});

var helper = require("./helpers/control.preview.js");

function describe(value) {
  if (value === null || value === undefined || value === "") return "";
  var txt = value instanceof Date ? "" : value.toString().trim();
  var date = null;
  if (value instanceof Date) {
    date = value;
  } else if (/^\d{8,17}$/.test(txt)) {
    date = new Date(Number(txt.substring(0, 4)), Number(txt.substring(4, 6)) - 1, Number(txt.substring(6, 8)));
  } else {
    var parsed = new Date(txt);
    if (!isNaN(parsed.getTime())) date = parsed;
  }
  if (!date || isNaN(date.getTime())) return txt;
  return date.toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });
}

exports.render = async function(options) {
  var text = describe(options.value);
  if (!text) {
    return helper.renderDoc({ n: "span", c: "ua-control-preview-empty", i: options.emptyText || "Not provided" });
  }
  return helper.renderDoc({ n: "span", c: "ua-control-preview-text", i: text });
};

/* Plain-text twin of render() for non-DOM surfaces (emails, logs, exports):
 * the same readable value, as a string. "" means nothing to show. */
exports.toText = function(options) {
  return describe((options || {}).value);
};
